module.exports = require("./sv-FI.d.ts");